var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#001D26;}\n\t.st1{fill:#31C5F0;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,111.2C38,111.2,16.8,90,16.8,64S38,16.8,64,16.8S111.2,38,111.2,64S90,111.2,64,111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64,19.7c24.4,0,44.3,19.9,44.3,44.3S88.4,108.3,64,108.3S19.7,88.4,19.7,64S39.6,19.7,64,19.7 M64,14    c-27.6,0-50,22.4-50,50s22.4,50,50,50s50-22.4,50-50S91.6,14,64,14L64,14z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.5,59.3c-2.8,0-3.8,1.4-3.8,2.6c0,1.3,0.6,2.2,4.4,4.1c5.6,2.7,7.4,5.3,7.4,9.1c0,5.7-4.4,8.8-10.3,8.8   c-3.1,0-5.8-0.6-7.3-1.5c-0.2-0.1-0.3-0.3-0.3-0.6v-5.2c0-0.4,0.2-0.5,0.4-0.3c2.2,1.5,4.8,2.1,7.2,2.1c2.8,0,4-1.2,4-2.8   c0-1.3-0.8-2.4-4.4-4.3c-5.1-2.4-7.2-4.9-7.2-9c0-4.6,3.6-8.4,9.9-8.4c3.1,0,5.2,0.5,6.4,1c0.3,0.2,0.4,0.5,0.4,0.7v4.9   c0,0.3-0.2,0.5-0.5,0.4C85.2,59.9,82.9,59.3,80.5,59.3L80.5,59.3z M49.8,63.6c0.8,0.1,1.5,0.1,2.9,0.1c4.2,0,8.1-1.5,8.1-7.1   c0-4.5-2.8-6.8-7.6-6.8c-1.4,0-2.8,0.1-3.4,0.1V63.6z M43.5,44.6c0-0.2,0.5-0.4,0.8-0.4c2.3-0.1,5.7-0.2,9.2-0.2   c9.9,0,13.7,5.4,13.7,12.4c0,9.1-6.6,13-14.6,13c-1.4,0-1.8-0.1-2.8-0.1V83c0,0.3-0.1,0.4-0.4,0.4h-5.5c-0.3,0-0.4-0.1-0.4-0.4   L43.5,44.6L43.5,44.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon22);
export default __webpack_public_path__ + "static/media/icon22.2a99964178f14788a9d18a6e2c8b50e5.svg";
export { ForwardRef as ReactComponent };